import TeamHero from "./TeamHero";

export default TeamHero;
